const gtmTrace = {
  addToCart(data) {
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: 'TWD',
        add: {
          products: [
            {
              name: typeof htmlDecode !== 'undefined' ? window.htmlDecode(data.name) : data.name,
              id: data.id,
              price: data.price,
              sale_price: data.sale_price,
              img_url: data.img_url,
              product_url: data.product_url,
              variant: data.color,
              quantity: data.count,
            },
          ],
        },
      },
    });
  },
  removeFromCart(data) {
    window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [
            {
              name: typeof htmlDecode !== 'undefined' ? window.htmlDecode(data.name) : data.name,
              id: data.id,
              price: data.price,
              sale_price: data.sale_price,
              img_url: data.img_url,
              product_url: data.product_url,
              variant: data.color,
              quantity: data.count,
            },
          ],
        },
      },
    });
  },
  checkout(data) {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          products: [
            {
              name: typeof htmlDecode !== 'undefined' ? window.htmlDecode(data.name) : data.name,
              id: data.id,
              price: data.price,
              sale_price: data.sale_price,
              img_url: data.img_url,
              product_url: data.product_url,
              variant: data.color,
              quantity: data.count,
            },
          ],
        },
      },
    });
  },
};

export default gtmTrace;
